"use client"

import { useQuery } from "@tanstack/react-query"
import {
  getAccountAlertChannelsAction,
  type AccountAlertChannelsView,
} from "@/server-actions/alert-channels"

export const alertChannelsQueryKey = ["notifications", "account-alert-channels"] as const

export function useAccountAlertChannelsQuery(enabled = true) {
  return useQuery<AccountAlertChannelsView>({
    queryKey: alertChannelsQueryKey,
    enabled,
    queryFn: async () => {
      const result = await getAccountAlertChannelsAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
